import { TriggerText as ConstellationTriggerText, Icon } from '@zillow/constellation-10';
import { forwardRef } from 'react';

type TriggerTextProps = {
  children: string;
  icon?: JSX.Element;
  onClick?: () => void;
};

const TriggerText = forwardRef<HTMLButtonElement, TriggerTextProps>(
  ({ children, icon, onClick }: TriggerTextProps, ref): JSX.Element => {
    return (
      <ConstellationTriggerText
        onClick={onClick ? onClick : undefined}
        ref={ref}
        css={{
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'nowrap',
        }}
      >
        {icon && <Icon css={{ display: 'flex', marginRight: 'tightest' }}>{icon}</Icon>}
        {children}
      </ConstellationTriggerText>
    );
  },
);

TriggerText.displayName = 'TriggerText';
export default TriggerText;
